import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import 'lenis/dist/lenis.css'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Sentry (~130 KB with tracing + replay) loads after the page, so it doesn't delay first paint.
// Trade-off: errors thrown before the window load event aren't reported.
function initSentry() {
  import('@sentry/react').then((Sentry) =>
    Sentry.init({
      dsn: 'https://7dceb70b0c94484fc082bcb8fad027a8@o4508625405018112.ingest.de.sentry.io/4508631044063312',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: [
        'localhost',
        /^https:\/\/yourserver\.io\/api/,
        /^https:\/\/yeldynov\.tech/,
      ],

      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })
  )
}

if (document.readyState === 'complete') initSentry()
else window.addEventListener('load', initSentry, { once: true })
